<main class="h-100">
    <router-outlet />
</main>

<!-- <ngx-spinner  color="#fff" type="ball-zig-zag-deflect" [fullScreen]="true">
    <p style="color: white"> {{'loading' | translate}} </p>
</ngx-spinner> -->
